<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text
      style="height: 100%;"
      class="pa-0"
    >
      <template v-if="por === 'asociacion'">
        <v-data-table
          must-sort
          :headers="headers"
          :items="items"
          :pagination.sync="paginacion"
          :total-items="totalItems"
          :rows-per-page-items="itemsPorPagina"
          :loading="cargando"
          class="elevation-1"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
            v-if="cargando"
          ></v-progress-linear>
          <template v-slot:items="props">
            <tr
              @click="seleccionarComprobante(props.item)"
              :class="{ secondary: itemSeleccionado && props.item.id === itemSeleccionado.id }"
            >
              <td class="text-xs-left">{{ props.item.facturado_por | nombreCentro }}</td>
              <td class="text-xs-left">{{ props.item.fecha }}</td>
              <td class="text-xs-left">{{ props.item.tipo_comprobante_categoria.nombre }}</td>
              <td class="text-xs-left">{{ props.item.numero_comprobante }}</td>
              <td class="text-xs-left">{{ props.item.punto_venta.numero }}</td>
              <td class="text-xs-left">{{ props.item.estado_facturacion.nombre }}</td>
              <td class="text-xs-right">{{ props.item.importe_prefacturado | currency }}</td>
              <td class="text-xs-right">{{ props.item.importe_facturado | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <template v-if="itemSeleccionado">
        <h4 class="px-3 my-2 secondary--text">Conceptos Facturados</h4>
        <span class="px-3 mb-3 primary--text">Total Pacientes {{totalPacientes}}</span>
        <v-data-table
          must-sort
          :headers="headersConceptos"
          :items="itemsConceptos"
          :pagination.sync="paginacionConceptos"
          :total-items="totalItemsConceptos"
          :rows-per-page-items="itemsPorPaginaConceptos"
          :loading="cargandoConceptos"
          class="elevation-1"
        >
          <v-progress-linear
            v-slot:progress
            color="blue"
            indeterminate
            v-if="cargandoConceptos"
          ></v-progress-linear>
          <template v-slot:items="props">
            <td class="text-xs-left">
              {{
                props.item.paciente_orden_prestacion.paciente.persona.apellido
                  .concat(', ')
                  .concat(props.item.paciente_orden_prestacion.paciente.persona.nombre)
              }}
            </td>
            <td class="text-xs-left">
              {{ props.item.paciente_orden_prestacion.obra_social_plan.numero_afiliado }}
            </td>
            <td class="text-xs-left">
              {{ props.item.paciente_orden_prestacion.tratamiento.tipo_tratamiento.nombre }}
            </td>
            <td class="text-xs-left">
              {{ props.item.tipo_facturable }}

              <v-tooltip
                bottom
                v-if="props.item.tipo_facturable === 'EVENTUAL'"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="primary"
                    dark
                    v-on="on"
                  >info</v-icon>
                </template>
                <span>{{ props.item.detalle_adicional }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-center">
              {{
                props.item.tipo_facturable === 'TRASLADO'
                  ? props.item.cantidad_total_km_traslados + ' km.'
                  : props.item.cantidad_sesiones_asistidas
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.tipo_facturable === 'EVENTUAL' ? '--' : props.item.modalidad_facturacion
              }}
            </td>
            <td class="text-xs-right">{{ props.item.importe_unitario | currency }}</td>
            <td class="text-xs-right">{{ props.item.importe_total | currency }}</td>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="false"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { formatoFecha, nombreCentro } from '@/helpers/filtros'
import Modelo from '@/api/comprobante'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'

export default {
  name: 'FacturacionDetalleComprobante',
  components: {
    BotonesCancelarGuardar
  },
  filters: {
    formatoFecha,
    nombreCentro
  },
  props: {
    titulo: {
      type: String
    },
    por: {
      type: String,
      required: true
    },
    comprobanteId: {
      type: Number,
      required: true
    },
    codigoTipoComprobante: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      filtros: {
        search: null
      },
      filtrosConceptos: {
        search: null
      },

      headers: [
        { text: 'Facturado Por', value: 'instituciones:institucion_id|instituciones.codigo', sortable: false },
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Cat', value: 'tipo_comprobante_categoria_id', sortable: false },
        { text: 'N°', value: 'numero_comprobante', sortable: false },
        { text: 'Pto.Vta.', value: 'punto_venta_id', sortable: false },
        { text: 'Est. Fac.', value: 'estado_facturacion_id', sortable: false },
        {
          text: 'Importe prefacturado',
          value: 'importe_prefacturado',
          sortable: false,
          align: 'right'
        },
        { text: 'Importe facturado', value: 'importe_facturado', sortable: false, align: 'right' }
      ],
      items: [],
      paginacion: {},
      totalItems: 0,
      itemsPorPagina: [20, 50, 100],

      headersConceptos: [
        {
          text: 'Paciente',
          value: 'id',
          // value:
          //  'paciente_ordenes_prestacion:paciente_orden_prestacion_id|paciente_ordenes_prestacion.paciente_id',
          sortable: false
        },
        { text: 'Nro. Afiliado', value: 'paciente_orden_prestacion_id', sortable: false },
        { text: 'Tratamiento', value: 'paciente_orden_prestacion_id', sortable: false },
        { text: 'Facturable', value: 'tipo_facturable', sortable: false },
        {
          text: 'Cantidad',
          value: 'cantidad_sesiones_asistidas',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Modalidad',
          value: 'paciente_orden_prestacion_id',
          sortable: false,
          align: 'center'
        },
        { text: 'Importe Unitario', value: 'importe_unitario', sortable: false, align: 'right' },
        { text: 'Importe Total', value: 'importe_total', sortable: false, align: 'right' }
      ],
      itemsConceptos: [],
      paginacionConceptos: {},
      totalItemsConceptos: 0,
      itemsPorPaginaConceptos: [20, 50, 100],

      cargando: false,
      cargandoConceptos: false,
      referencia: {
        type: String,
        required: true
      },
      itemSeleccionado: null,
      totalPacientes: 0
    }
  },
  watch: {
    paginacion: {
      handler () {
        this.filtrarDatos()
      },
      deep: true
    },
    paginacionConceptos: {
      handler (nuevo, viejo) {
        if (!nuevo.page) {
          this.filtrarConceptos()
        }
      },
      deep: true
    }
  },
  mounted () {
    let vm = this

    if (vm.por === 'asociacion') {
      vm.filtrar('comprobantes')
    } else {
      vm.itemSeleccionado = {
        id: vm.comprobanteId
      }
      this.filtrar('conceptos')
    }
  },
  methods: {
    filtrar (tabla) {
      let vm = this
      if (tabla === 'comprobantes') {
        vm.filtros.page = 1
        vm.filtrarDatos()
      } else {
        vm.filtrosConceptos.page = 1
        vm.filtrarConceptos()
      }
    },

    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      vm.metodoFiltrar('comprobantes', _filtros).then(
        data => {
          vm.items.lenght = 0
          vm.items = data.data
          vm.totalItems = data.total
          vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    filtrarConceptos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtrosConceptos)

      if (vm.cargandoConceptos) {
        return false
      }
      // _filtros.page = vm.paginacionConceptos.page
      // _filtros.perPage = vm.paginacionConceptos.rowsPerPage
      _filtros.orderBy = vm.paginacionConceptos.sortBy
      _filtros.sortedBy = vm.paginacionConceptos.descending ? 'desc' : 'asc'

      vm.cargandoConceptos = true
      vm.metodoFiltrar('conceptos', _filtros).then(
        data => {
          vm.itemsConceptos.lenght = 0
          vm.itemsConceptos = vm.ordenarConceptos(data)
          vm.totalItemsConceptos = data.lenght
          vm.cargandoConceptos = false

          var pacientesPorNroAfiliado = _.countBy(vm.itemsConceptos, 'paciente_orden_prestacion.obra_social_plan.numero_afiliado')
          vm.totalPacientes = _.size(pacientesPorNroAfiliado)
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargandoConceptos = false
        }
      )
    },
    seleccionarComprobante (item) {
      this.itemSeleccionado = item
      this.filtrar('conceptos')
    },

    cerrar () {
      this.$emit('alCerrar')
    },

    metodoFiltrar (tabla, filtros) {
      let vm = this
      if (tabla === 'comprobantes') {
        filtros.por = vm.por
        filtros.comprobanteId = vm.comprobanteId
        filtros.codigoTipoComprobante = vm.codigoTipoComprobante
        return Modelo.obtenerDetalleComprobante(filtros)
      } else {
        filtros.por = vm.por
        filtros.comprobanteId = vm.itemSeleccionado.id
        return Modelo.obtenerConceptosComprobante(filtros)
      }
    },

    ordenarConceptos (data) {
      let dataOrdenada = _.forEach(data, item => {
        item.nombre_completo = item.paciente_orden_prestacion.paciente.persona.apellido.concat(', ').concat(item.paciente_orden_prestacion.paciente.persona.nombre).toUpperCase()
      })
      dataOrdenada = _.sortBy(dataOrdenada, item => {
        return item.nombre_completo
      })
      return dataOrdenada
    }
  }
}
</script>
<style scoped></style>
